var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("application-page-loader", {
        staticClass: "mt-4",
        staticStyle: { height: "70vh !important" },
      })
    : _c(
        "div",
        { staticClass: "row", attrs: { id: "application-visibility" } },
        [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              { staticClass: "row application-visibility" },
              [
                _c(
                  "div",
                  { staticClass: "col-12 d-flex justify-content-end" },
                  [
                    !_vm.saving
                      ? _c(
                          "p",
                          { staticClass: "font-italic text-right mb-1" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("global.actions.lastSaved")) +
                                ":\n          " +
                                _vm._s(
                                  _vm.updatedAt
                                    ? _vm.formatTimeAgo(_vm.updatedAt)
                                    : _vm.$t("global.words.never")
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _c(
                          "p",
                          { staticClass: "font-italic text-right mb-1" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("global.words.saving")) +
                                "...\n        "
                            ),
                          ]
                        ),
                  ]
                ),
                _vm._v(" "),
                _vm.isBrokerage ? _c("application-form-overrides") : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-auto pr-0" },
                  [
                    _c("application-flow-dropdown", {
                      staticClass: "card flow-dropdown px-3",
                      attrs: {
                        flows: _vm.flows,
                        "current-flow": _vm.currentFlow.key,
                        "application-id": null,
                        "client-username": null,
                        badge: false,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col pl-0 small-nav-wrapper" },
                  [
                    _c("application-dropdown-navigation", {
                      staticStyle: { "margin-left": "5px !important" },
                      attrs: {
                        loading: _vm.loading,
                        page: _vm.currentPage,
                        application: _vm.applicationInfo,
                        "edit-visibility": "",
                      },
                      on: { "page-change": _vm.handlePageChange },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              {
                ref: "mortgageContainer",
                staticClass: "pr-1",
                attrs: { id: "app-data-container" },
              },
              [
                _c("application-form", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "application-id": null,
                    "edit-visibility": true,
                    "is-brokerage": _vm.isBrokerage,
                    "client-username": null,
                    "agent-username": null,
                    validator: null,
                    loading: _vm.loading,
                  },
                  on: { "page-change": _vm.handlePageChange },
                }),
              ],
              1
            ),
          ]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }